import Headline from "./components/Headline";
import TaschenrechnerContainer from "./components/TaschenrechnerKomponenten/TaschenrechnerContainer";

import RechnerContainer from "./components/BruttoNettoRechnerKomponenten/BruttoNettoRContainer";

function App() {
  return (
    <>
      {/* <Headline /> */}
      {/* <TaschenrechnerContainer /> */}

      <RechnerContainer />
    </>
  );
}

export default App;
